import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from '../../../../atoms/material-icons';
import PropTypes from 'prop-types';
import './futures-accordion.m.css';

const FuturesAccordion = ({ items }) => {
  const [activeIndex, setActiveIndex] = useState(-1);

  const handleClick = index => {
    setActiveIndex(index === activeIndex ? -1 : index);
  };

  return (
    <div styleName="accordion-card-container">
      {items?.map((item, index) => (
        <div key={item.title} styleName="accordion-card" onClick={() => handleClick(index)}>
          <div styleName="text-dropdown-container">
            <span styleName="title">{item.title}</span>
            <button styleName="dropdown-button">
              {index === activeIndex ? (
                <ChevronUpIcon size={'26px'} />
              ) : (
                <ChevronDownIcon size={'26px'} />
              )}
            </button>
          </div>

          {index === activeIndex && <p styleName="content">{item.content}</p>}
        </div>
      ))}
    </div>
  );
};

FuturesAccordion.propTypes = {
  items: PropTypes.array
};

export default FuturesAccordion;
